import classNames from 'classnames';
import React from 'react';
import AddOptionInput from './add-option-input';

const ListWrapper = ({
  hasSingleItem,
  newItem,
  handleInputChange,
  handleAddClick,
  placeholderText,
  ariaLabel,
  children,
  autoFocusInput,
}) => {
  return (
    <div className="c-letter-slide-list">
      <ul
        className={classNames({
          'c-letter-slide-list__container': true,
          'c-letter-slide-list__container--single-item': hasSingleItem,
        })}
      >
        {children}
        <li>
          <AddOptionInput
            inputValue={newItem}
            onInputChange={handleInputChange}
            onClick={handleAddClick}
            placeholderText={placeholderText}
            ariaLabel={ariaLabel}
            autoFocus={autoFocusInput}
          />
        </li>
      </ul>
    </div>
  );
};

export default ListWrapper;
